/* UGC: sections/nextdev-ugc.liquid, assets/nextdev-ugc.css.

   The row lays itself out in the css: in the middle when it fits, a carousel
   when it does not. This says which it is, with --scrolls on the root, so the
   arrows show; it moves the row a screenful at a time from the arrows, turns
   each off at its end, and lets a mouse drag the row the way a finger does.
   It runs again for a section the theme editor adds or redraws. */
(function () {
  var GAP = 16;

  var init = function (root) {
    if (root.hasAttribute('data-nextdev-ugc-ready')) return;
    root.setAttribute('data-nextdev-ugc-ready', '');
    var row = root.querySelector('[data-nextdev-ugc-row]');
    if (!row) return;
    var prev = root.querySelector('[data-nextdev-ugc-prev]');
    var next = root.querySelector('[data-nextdev-ugc-next]');

    var update = function () {
      var max = row.scrollWidth - row.clientWidth;
      var scrolls = max > 1;
      root.classList.toggle('nextdev--ugc--scrolls', scrolls);
      if (prev) prev.disabled = !scrolls || row.scrollLeft <= 1;
      if (next) next.disabled = !scrolls || row.scrollLeft >= max - 1;
    };

    // one card and the gap after it
    var pitch = function () {
      var card = row.querySelector('.nextdev--ugc__card');
      return card ? card.offsetWidth + GAP : 256;
    };

    // as many whole cards as the screen shows, at least one
    var step = function (dir) {
      var inset = parseFloat(getComputedStyle(row).paddingLeft) || 0;
      var each = pitch();
      var count = Math.max(1, Math.floor((row.clientWidth - 2 * inset + GAP) / each));
      row.scrollBy({ left: dir * count * each, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    row.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(row);
    } else {
      window.addEventListener('resize', update);
    }
    update();

    // ---- a mouse drags the row ----
    // A finger and a trackpad scroll it already. Snapping is off while the
    // mouse holds it, and on letting go the row glides to the nearest card
    // before snapping comes back, so it does not jump. A drag that moved is
    // not also a click.
    var held = null;
    var moved = false;
    var settle = null;

    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (!root.classList.contains('nextdev--ugc--scrolls')) return;
      held = { x: e.clientX, left: row.scrollLeft };
      moved = false;
    });

    window.addEventListener('pointermove', function (e) {
      if (!held) return;
      var dx = e.clientX - held.x;
      if (!moved) {
        if (Math.abs(dx) < 4) return;
        moved = true;
        clearTimeout(settle);
        row.classList.add('nextdev--ugc__row--dragging');
      }
      row.scrollLeft = held.left - dx;
    });

    var letGo = function () {
      if (!held) return;
      held = null;
      if (!moved) return;
      var each = pitch();
      var max = row.scrollWidth - row.clientWidth;
      row.scrollTo({ left: Math.min(max, Math.round(row.scrollLeft / each) * each), behavior: 'smooth' });
      settle = setTimeout(function () {
        row.classList.remove('nextdev--ugc__row--dragging');
      }, 450);
      // the click a drag ends with is swallowed; one that never comes, when
      // the mouse is let go off the row, leaves no catch behind for later
      var swallow = function (e) {
        e.preventDefault();
        e.stopPropagation();
      };
      row.addEventListener('click', swallow, true);
      setTimeout(function () { row.removeEventListener('click', swallow, true); }, 0);
    };
    window.addEventListener('pointerup', letGo);
    window.addEventListener('pointercancel', letGo);
  };

  var all = function (scope) {
    scope.querySelectorAll('[data-nextdev-ugc]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { all(document); });
  } else {
    all(document);
  }
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
